import { APP, WS_DATA } from './app.constants';

export const ACTIVITY = `${APP}_activity`;

// The entities an Activity feed can be opened on. These values are the API's History.HistoryType
// strings and go straight into the `/-/activity/{type}/{id}` route, so they must match it.
export const ACTIVITY_TYPE_DEVICE = 'device';
export const ACTIVITY_TYPE_GEOFENCE = 'geofence';

export const WS_DATA_DEVICE_COMMENT = `${WS_DATA}/deviceComment`;
export const WS_DATA_GEOFENCE_COMMENT = `${WS_DATA}/geofenceComment`;

export const GET_ACTIVITY = `${ACTIVITY}/GET_ACTIVITY`;
export const ACTIVITY_CHANGED = `${ACTIVITY}/ACTIVITY_CHANGED`;
export const ADD_COMMENT = `${ACTIVITY}/ADD_COMMENT`;
export const COMMENT_RECEIVED = `${ACTIVITY}/COMMENT_RECEIVED`;
export const SET_ACTIVITY_LOADING = `${ACTIVITY}/SET_ACTIVITY_LOADING`;
